'use client'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ControlledMenu } from '@szhsin/react-menu'
import MUIBackdrop from '@mui/material/Backdrop'
import { Portal } from '@mui/base/Portal'

export const PopupWithBackdrop = ({
  children,
  anchorRef,
  arrow = false,
  className,
  handleClick,
  menuState,
  toggleMenu,
  zIndex = 99,
  shift = 0
}) => {
  const [menuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    const isOpen = menuState?.state?.includes('open')
    setMenuOpen(isOpen)
  }, [menuState])

  useEffect(() => {
    if (toggleMenu) toggleMenu(false)
  }, [toggleMenu])

  return (
    <>
      <ControlledMenu
        {...menuState}
        anchorRef={anchorRef}
        transition={{ close: false }}
        className={className}
        submenuOpenDelay={50}
        arrow={arrow}
        portal
        shift={shift}
      >
        {children}
      </ControlledMenu>

      <Portal>
        <MUIBackdrop
          data-testid="PopupWithBackdrop"
          open={menuOpen || false}
          onClick={() => {
            if (handleClick) handleClick()
            toggleMenu(false)
          }}
          sx={{
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            position: 'fixed',
            zIndex,
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            cursor: 'pointer'
          }}
        />
      </Portal>
    </>
  )
}

PopupWithBackdrop.propTypes = {
  children: PropTypes.node,
  anchorRef: PropTypes.any,
  arrow: PropTypes.bool,
  className: PropTypes.string,
  handleClick: PropTypes.func,
  menuState: PropTypes.any,
  toggleMenu: PropTypes.func,
  zIndex: PropTypes.number,
  shift: PropTypes.number
}
